<template>
  <v-container>
    <v-card class="my-5 elevation-0" height="100%">
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <!-- Native iframe has its own download functionality -->
        <!-- <v-btn small color="primary" @click="downloadLink(contractDocument)">
          <v-icon left color="white"> mdi-download </v-icon>
          Download
        </v-btn> -->
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <v-card-text
            v-if="contractDocument"
            class="pa-0 elevation-1 mb-1"
            :style="{
              height: isMobile ? 'auto' : '80vh',
              minHeight: isMobile ? '300px' : '700px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div
                v-if="isMobile"
                class="pa-12 text-center d-flex flex-column align-center justify-center"
              >
                <v-icon size="100" color="primary lighten-4"
                  >mdi-file-pdf-box</v-icon
                >
                <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
                  Contract Letter Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  Your contract letter is ready. Since you are on a mobile device,
                  please use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Contract Letter
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                :src="pdfUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="Contract Letter Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </v-card-text>
        </v-col>
      </v-row>
      <v-divider />
      <v-divider />
      <v-card-title class="pb-6">
        <div class="style-button">
          <v-btn
            text
            small
            class="reject red"
            color="#FFFFFF"
            @click="showRejectModal()"
          >
            Reject
          </v-btn>
          <v-btn
            small
            class="accept teal"
            color="#FFFFFF"
            @click="showAcceptContractModal()"
          >
            Accept
          </v-btn>
        </div>
      </v-card-title>
    </v-card>
    <RejectContractModal
      :showModal="rejectModal"
      :rejectModal="rejectModalFormFields"
      @setModal="showRejectModal"
      @setRejectPayLoad="rejectContract"
    />
    <AcceptContractModal
      :showModal="acceptModal"
      :otp="contractAcceptanceOTP"
      @setModal="showAcceptContractModal"
      @setAcceptanceData="acceptContract"
    />
  </v-container>
</template>

<script>
import FileMixin from "@kinetics254/cassandra-base/mixins/FileMixin";
import RejectContractModal from "./RejectContractModal.vue";
import AcceptContractModal from "./AcceptContractModal.vue";
export default {
  name: "ViewContractLetter",
  mixins: [FileMixin],
  components: { RejectContractModal, AcceptContractModal },
  data: function () {
    return {
      pdfUrl: null,
      numPages: undefined,
      rejectModal: false,
      acceptModal: false,
      contractAcceptanceOTP: "",
      rejectModalFormFields: [
        {
          label: "Reason For Decline",
          name: "reasonForDecline",
          type: "text",
          value: "",
        },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.getContractDocument();
    });
  },
  computed: {
    userData() {
      return this.$store.getters["auth/user"];
    },
    contractDocument() {
      return this.$store.getters["Dashboard/contractLetter"][0];
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    contractDocument: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.generatePdfUrl(newValue);
        }
      },
    },
  },
  methods: {
    generatePdfUrl(base64Data) {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      try {
        const binaryString = window.atob(base64Data);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error generating PDF URL", e);
      }
    },
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
    getContractDocument() {
      this.$store.dispatch("Dashboard/getContractLetter", {
        contractNo: this.$route.params.contractNo,
      });
    },
    acceptContract(args) {
      this.$store.dispatch("Dashboard/acceptContract", {
        contractNo: this.$route.params.contractNo,
        ...args,
      });
      setTimeout(
        this.$router.push({
          name: "Contract",
        }),
        1600
      );
    },
    rejectContract(args) {
      this.$store.dispatch("Dashboard/rejectContract", {
        No: this.$route.params.contractNo,
        status: "Declined",
        ...args,
      });
      setTimeout(
        this.$router.push({
          name: "Contract",
        }),
        1600
      );
    },
    // Show Modal
    showRejectModal() {
      this.rejectModal = !this.rejectModal;
    },
    showAcceptContractModal() {
      this.acceptModal ? "" : this.sendContractAcceptanceOTP();
      this.acceptModal = !this.acceptModal;
      this.contractAcceptanceOTP = "";
    },
    sendContractAcceptanceOTP() {
      this.$store.dispatch("Dashboard/getContractAcceptanceOTP", {
        contractNo: this.$route.params.contractNo,
        email: this.userData.profile.email,
        phone: this.userData.phone_no,
      });
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>
<style>
@media (max-width: 600px) {
  .reject {
    min-width: 20%;
    padding-inline: 2%;
    display: block;
    position: absolute;
    top: 0;
    left: 10%;
  }
  .accept {
    min-width: 20%;
    padding-inline: 2%;
    display: block;
    position: absolute;
    top: 0;
    right: 10%;
  }
}
@media (min-width: 600px) {
  .reject {
    display: block;
    position: absolute;
    top: 0;
    left: 30%;
    width: 8%;
    color: #fff;
  }

  .accept {
    display: block;
    position: absolute;
    top: 0;
    right: 30%;
    width: 8%;
  }
}
.style-button {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding-bottom: 5%;
}
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
<style>
@media (max-width: 600px) {
  .reject {
    min-width: 20%;
    padding-inline: 2%;
    display: block;
    position: absolute;
    top: 0;
    left: 10%;
  }
  .accept {
    min-width: 20%;
    padding-inline: 2%;
    display: block;
    position: absolute;
    top: 0;
    right: 10%;
  }
}
@media (min-width: 600px) {
  .reject {
    display: block;
    position: absolute;
    top: 0;
    left: 30%;
    width: 8%;
    color: #fff;
  }

  .accept {
    display: block;
    position: absolute;
    top: 0;
    right: 30%;
    width: 8%;
  }
}
.style-button {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding-bottom: 5%;
}
</style>
